import styled from "styled-components";

export const StyledSpinner = styled.div`
  background-color: white;
  width: 64px;
  height: 64px;
  border: 8px solid;
  border-color: #999999 transparent #cccccc transparent;
  border-radius: 50%;
  animation: spin 1.2s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
